/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'label-new': {
    width: 19,
    height: 18,
    viewBox: '0 0 19 18',
    data: '<path pid="0" d="M17.857 0c.355 0 .643.288.643.643v6.755c0 .526-.205 1.02-.578 1.393L9.29 17.424a1.972 1.972 0 01-2.786 0l-5.426-5.426a1.97 1.97 0 010-2.788L9.71.578A1.956 1.956 0 0111.103 0zm-.642 1.286h-6.112a.68.68 0 00-.483.2L1.987 10.12a.685.685 0 000 .97l5.426 5.426a.685.685 0 00.968 0l8.633-8.633c.128-.13.2-.3.2-.484V1.286zM6.098 9.19l3.214 3.215a.643.643 0 11-.909.909l-3.214-3.215a.643.643 0 11.909-.909zm2.571-2.571l3.214 3.214a.643.643 0 11-.909.91L7.76 7.526a.643.643 0 11.91-.91zM14 2.572A1.93 1.93 0 0115.93 4.5 1.93 1.93 0 0114 6.43a1.93 1.93 0 01-1.928-1.93A1.93 1.93 0 0114 2.572zm0 1.286a.644.644 0 10.002 1.287A.644.644 0 0014 3.858z" _fill="#213F6B" fill-rule="evenodd"/>'
  }
})
